<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <h1>{{ importedTitle }}</h1>
    <div class="center">
      <input
        type="text"
        v-model="answer"
        v-on:keyup.enter="validate"
        :maxlength="importedLength"
        ref="secret"
      />
    </div>
    <div class="center">
      <p class="error" v-if="message">{{ message }}</p>
    </div>
    <div class="button-wrapper">
      <p @click="validate">Valider</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro",
  components: {},
  props: {
    title: String,
    password: String,
    password2: String,
    length: { type: Number, default: 13 },
  },
  data() {
    return {
      importedTitle: this.title,
      importedPassword: this.password,
      importedPassword2: this.password2,
      importedLength: this.length,
      answer: null,
      message: null,
    };
  },
  methods: {
    validate() {
      this.message = null;
      if (
        this.removeAccents(this.answer).toUpperCase() === this.importedPassword2
      )
        this.$emit("next");
      this.removeAccents(this.answer).toUpperCase() ===
      this.importedPassword.toUpperCase()
        ? this.$emit("next")
        : (this.message = "Mauvaise réponse !");
    },
    removeAccents(str) {
      var accents =
        "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
      var accentsOut =
        "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      str = str.split("");
      var strLen = str.length;
      var i, x;
      for (i = 0; i < strLen; i++) {
        if ((x = accents.indexOf(str[i])) != -1) {
          str[i] = accentsOut[x];
        }
      }
      return str.join("");
    },
  },
  mounted() {
    this.$refs.secret.focus();
  },
};
</script>

<style scoped>
.container {
  background: rgb(220, 220, 220);
  padding: 5px 20px;
  overflow: scroll;
  position: relative;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}

input {
  font-size: 40px;
  max-width: 280px;
  letter-spacing: 4px;
  font-family: "VT323", monospace;
  font-weight: bold;
  text-align: center;
  background: rgb(250, 250, 250);
  line-height: 15px;
  color: rgb(80, 80, 80);
  border: none;
  text-transform: uppercase;
  border-bottom: 4px solid rgb(80, 80, 80);
}
input:focus {
  outline: none;
}
.error {
  color: #8b0102;
  font-weight: bold;
}
</style>
